export const dataMonitoreos = {
  2015: [
    {
      id: 1,
      monthBoletin: "NOV",
      nameBoletin: "primer-informe-4-al-15-de-noviembre-de-2015",
    },
    {
      id: 2,
      monthBoletin: "NOV",
      nameBoletin: "Comunicado 001 APRUEBA ITE REGLAMENTO DE SESIONES",
    },
    {
      id: 3,
      monthBoletin: "DIC",
      nameBoletin: "tercer-informe-30-al-13-de-diciembre-de-2015",
    },
    {
      id: 4,
      monthBoletin: "DIC",
      nameBoletin: "cuarto-informe-14-al-27-de-diciembre-de-2015",
    },
    {
      id: 5,
      monthBoletin: "DIC",
      nameBoletin: "quinto-informe-28-de-diciembre-al-10-de-enero-de-2016",
    },
  ],

  2016: [
    {
      id: 1,
      monthBoletin: "ENE",
      nameBoletin: "1ER.-INFORME-CONCENTRADO-MENSUAL",
    },
    {
      id: 2,
      monthBoletin: "ENE",
      nameBoletin: "sexto-informe-11-al-24-de-enero-de-2016",
    },
    {
      id: 3,
      monthBoletin: "ENE",
      nameBoletin: "séptimo-informe-25-de-enero-al-7-de-febrero-de-2016",
    },
    {
      id: 4,
      monthBoletin: "FEB",
      nameBoletin: "2DO.-INFORME-CONCENTRADO-MENSUAL",
    },
    {
      id: 5,
      monthBoletin: "FEB",
      nameBoletin: "Noveno Informe (22 de febrero al 6 de marzo)",
    },
    {
      id: 6,
      monthBoletin: "FEB",
      nameBoletin: "octavo informe (8 al 21 de febrero de 2016)",
    },
    {
      id: 7,
      monthBoletin: "MAR",
      nameBoletin: "3ER.-INFORME-CONCENTRADO-MENSUAL",
    },
    {
      id: 8,
      monthBoletin: "MAR",
      nameBoletin: "DECIMO-INFORME 07-20 marzo",
    },
    {
      id: 9,
      monthBoletin: "MAR",
      nameBoletin: "DECIMO-PRIMER-INFORME 21-03 ABRIL",
    },
    {
      id: 10,
      monthBoletin: "ABR",
      nameBoletin: "4TO.-INFORME-CONCENTRADO-MENSUAL",
    },
    {
      id: 11,
      monthBoletin: "ABR",
      nameBoletin: "DECIMO-SEGUNDO-INFORME",
    },
    {
      id: 12,
      monthBoletin: "ABR",
      nameBoletin: "DECIMO-TERCER-INFORME",
    },
    {
      id: 13,
      monthBoletin: "MAY",
      nameBoletin: "5TO.-INFORME-CONCENTRADO-MENSUAL",
    },
    {
      id: 14,
      monthBoletin: "MAY",
      nameBoletin: "DECIMO-CUARTO-INFORME-MONITOREO",
    },
    {
      id: 15,
      monthBoletin: "MAY",
      nameBoletin: "INFORME-DECIMO-QUINTO",
    },
    {
      id: 16,
      monthBoletin: "JUN",
      nameBoletin: "INFORME-DECIMO-SEXTO",
    },
  ],

  2017: [
    {
      id: 1,
      monthBoletin: "MAR",
      nameBoletin: "PRIMER-INFORME-MENSUAL",
    },
    {
      id: 2,
      monthBoletin: "MAR",
      nameBoletin: "PRIMER-INFORME-QUINCENAL",
    },
    {
      id: 3,
      monthBoletin: "ABR",
      nameBoletin: "INFORME-SEGUNDO-MONITOREO",
    },
    {
      id: 4,
      monthBoletin: "MAY",
      nameBoletin: "INFORME QUINTO MONITOREO",
    },
    {
      id: 5,
      monthBoletin: "MAY",
      nameBoletin: "INFORME-CUARTO-MONITOREO",
    },
    {
      id: 6,
      monthBoletin: "MAY",
      nameBoletin: "TERCER INFORME MENSUAL",
    },
    {
      id: 7,
      monthBoletin: "JUN",
      nameBoletin: "INFORME-FINAL-MONITOREO",
    },
    {
      id: 8,
      monthBoletin: "JUN",
      nameBoletin: "INFORME-SEXTO-MONITOREO",
    },
    {
      id: 9,
      monthBoletin: "DIC",
      nameBoletin: "Primer-Informe-Quincenal-PELO-2018",
    },
    {
      id: 10,
      monthBoletin: "DIC",
      nameBoletin: "Segundo-Informe-Quincenal-PELO-2018",
    },
  ],

  2018: [
    {
      id: 1,
      monthBoletin: "ENE",
      nameBoletin: "Tercer-Informe-Quincenal-PELO-2018",
    },
    {
      id: 2,
      monthBoletin: "ENE",
      nameBoletin: "1er Informe de monitoreo de radio y televisión",
    },
    {
      id: 3,
      monthBoletin: "ENE",
      nameBoletin: "2do Informe de monitoreo de radio y televisión",
    },
    {
      id: 4,
      monthBoletin: "FEB",
      nameBoletin: "Sexto-Informe-Quincenal-PELO-2018",
    },
    {
      id: 5,
      monthBoletin: "MAR",
      nameBoletin: "Septimo-Informe-Quincenal-PELO-2018",
    },
    {
      id: 6,
      monthBoletin: "ABR",
      nameBoletin: "Octavo-informe-Quincenal-PELO-2018",
    },
    {
      id: 7,
      monthBoletin: "ABR",
      nameBoletin: "Noveno-informe-Quincenal-PELO-2018",
    },
    {
      id: 8,
      monthBoletin: "ABR",
      nameBoletin: "Decimo-Informe-Quincenal-PELO-2018",
    },
    {
      id: 9,
      monthBoletin: "MAY",
      nameBoletin: "Onceavo-Informe-Quincenal-PELO-2018",
    },
    {
      id: 10,
      monthBoletin: "MAY",
      nameBoletin: "Doceavo Informe Quincenal PELO 2018",
    },
    {
      id: 11,
      monthBoletin: "MAY",
      nameBoletin: "Treceavo Informe Quincenal PELO 2018",
    },
    {
      id: 12,
      monthBoletin: "JUN",
      nameBoletin: "Catorceavo Informe Quincenal PELO 2018",
    },
    {
      id: 13,
      monthBoletin: "JUL",
      nameBoletin: "Informe final PELO 2018",
    },
  ],

  2020: [
    {
      id: 1,
      monthBoletin: "NOV",
      nameBoletin: "Tercer-Informe-Quincenal-PELO-2018",
    },
    {
      id: 2,
      monthBoletin: "NOV",
      nameBoletin: "PRIMER INFORME MONITOREO MIyD PELO 2020-2021",
    },
    {
      id: 3,
      monthBoletin: "NOV",
      nameBoletin: "SEGUNDO INFORME MONITOREO MIyD",
    },
    {
      id: 4,
      monthBoletin: "DIC",
      nameBoletin: "1er Informe de monitoreo con perspectiva de género",
    },
    {
      id: 5,
      monthBoletin: "DIC",
      nameBoletin: "CUARTO INFORME MONITOREO MIyD",
    },
    {
      id: 6,
      monthBoletin: "DIC",
      nameBoletin: "PRIMER INFORME MONITOREO PdG",
    },
    {
      id: 7,
      monthBoletin: "DIC",
      nameBoletin: "PRIMER INFORME MONITOREO RyT",
    },
    {
      id: 8,
      monthBoletin: "DIC",
      nameBoletin: "TERCER INFORME MONITOREO MIyD",
    },
    {
      id: 9,
      monthBoletin: "DIC",
      nameBoletin: "TERCER INFORME MONITOREO MIyD",
    },
    {
      id: 10,
      monthBoletin: "DIC",
      nameBoletin: "CUARTO INFORME MONITOREO MIyD",
    },
    {
      id: 11,
      monthBoletin: "DIC",
      nameBoletin: "1er Informe de monitoreo de radio y televisión",
    },
  ],

  2021: [
    {
      id: 1,
      monthBoletin: "ENE",
      nameBoletin: "QUINTO INFORME MONITOREO MIyD",
    },
    {
      id: 2,
      monthBoletin: "ENE",
      nameBoletin: "SEGUNDO INFORME MONITOREO PdG",
    },
    {
      id: 3,
      monthBoletin: "ENE",
      nameBoletin: "SEGUNDO INFORME MONITOREO RyT",
    },
    {
      id: 4,
      monthBoletin: "ENE",
      nameBoletin: "SEXTO INFORME MONITOREO MIyD",
    },
    {
      id: 5,
      monthBoletin: "ENE",
      nameBoletin: "TERCER INFORME MONITOREO PdG",
    },
    {
      id: 6,
      monthBoletin: "ENE",
      nameBoletin: "TERCER INFORME MONITOREO RyT",
    },
    {
      id: 7,
      monthBoletin: "ENE",
      nameBoletin: "QUINTO INFORME MONITOREO",
    },
    {
      id: 8,
      monthBoletin: "ENE",
      nameBoletin: "SEXTO INFORME MONITOREO",
    },
    {
      id: 9,
      monthBoletin: "ENE",
      nameBoletin: "SEGUNDO INFORME MONITOREO",
    },
    {
      id: 10,
      monthBoletin: "ENE",
      nameBoletin: "TERCER INFORME MONITOREO",
    },
    {
      id: 11,
      monthBoletin: "FEB",
      nameBoletin: "SEPTIMO INFORME MONITOREO MIyD",
    },
    {
      id: 12,
      monthBoletin: "FEB",
      nameBoletin: "SÉPTIMO INFORME MONITOREO",
    },
    {
      id: 13,
      monthBoletin: "FEB",
      nameBoletin: "OCTAVO INFORME MONITOREO",
    },
    {
      id: 14,
      monthBoletin: "MAR",
      nameBoletin: "DECIMO INFORME MONITOREO MIyD",
    },
    {
      id: 15,
      monthBoletin: "MAR",
      nameBoletin: "NOVENO INFORME MONITOREO MIyD",
    },
    {
      id: 16,
      monthBoletin: "MAR",
      nameBoletin: "OCTAVO INFORME MONITOREO MIyD",
    },
    {
      id: 17,
      monthBoletin: "MAR",
      nameBoletin: "NOVENO INFORME MONITOREO MIyD",
    },
    {
      id: 18,
      monthBoletin: "MAR",
      nameBoletin: "DECIMO INFORME MONITOREO MIyD",
    },
    {
      id: 19,
      monthBoletin: "ABR",
      nameBoletin: "ONCEAVO INFORME MONITOREO MIyD",
    },
    {
      id: 20,
      monthBoletin: "ABR",
      nameBoletin: "DUODECIMO INFORME MONITOREO MIyD",
    },
    {
      id: 21,
      monthBoletin: "ABR",
      nameBoletin: "CUARTO INFORME MONITOREO RyT",
    },
    {
      id: 22,
      monthBoletin: "ABR",
      nameBoletin: "QUINTO INFORME MONITOREO RyT",
    },
    {
      id: 23,
      monthBoletin: "MAY",
      nameBoletin: "DECIMOTERCERO INFORME MONITOREO MIyD",
    },
    {
      id: 24,
      monthBoletin: "MAY",
      nameBoletin: "DECIMOCUARTO INFORME MONITOREO MIyD",
    },
    {
      id: 25,
      monthBoletin: "MAY",
      nameBoletin: "SEXTO INFORME MONITOREO RyT",
    },
    {
      id: 26,
      monthBoletin: "MAY",
      nameBoletin: "SEPTIMO INFORME MONITOREO RyT",
    },
    {
      id: 27,
      monthBoletin: "JUN",
      nameBoletin: "INFORME FINAL MIyD",
    },
    {
      id: 28,
      monthBoletin: "JUN",
      nameBoletin: "INFORME FINAL MONITOREO RyT",
    },
    {
      id: 29,
      monthBoletin: "OCT",
      nameBoletin: "Primer Informe Quincenal",
    },
    {
      id: 30,
      monthBoletin: "OCT",
      nameBoletin: "Segundo Informe Monitoreo IyD",
    },
    {
      id: 31,
      monthBoletin: "OCT",
      nameBoletin: "Tercer Informe Monitoreo IyD",
    },
    {
      id: 32,
      monthBoletin: "OCT",
      nameBoletin: "Primer Informe Radio y Televisión",
    },
    {
      id: 33,
      monthBoletin: "NOV",
      nameBoletin: "Cuarto Informe Monitoreo IyD",
    },
    {
      id: 34,
      monthBoletin: "NOV",
      nameBoletin: "Informe Final Monitoreo IyD",
    },
    {
      id: 35,
      monthBoletin: "NOV",
      nameBoletin: "Segundo Informe Radio y Televisión",
    },
    {
      id: 36,
      monthBoletin: "NOV",
      nameBoletin: "Informe Final Monitoreo RyT",
    },
    {
      id: 37,
      monthBoletin: "DIC",
      nameBoletin: "SEGUNDO INFORME MONITOREO PdG",
    },
    {
      id: 38,
      monthBoletin: "DIC",
      nameBoletin: "TERCER INFORME MONITOREO",
    },
    {
      id: 39,
      monthBoletin: "DIC",
      nameBoletin: "CUARTO INFORME MONITOREO PdG",
    },
    {
      id: 40,
      monthBoletin: "DIC",
      nameBoletin: "QUINTO INFORME MONITOREO PdG",
    },
    {
      id: 41,
      monthBoletin: "DIC",
      nameBoletin: "SEXTO INFORME MONITOREO PdG",
    },
    {
      id: 42,
      monthBoletin: "DIC",
      nameBoletin: "SEPTIMO INFORME MONITOREO PdG",
    },
    {
      id: 43,
      monthBoletin: "DIC",
      nameBoletin: "INFORME FINAL MONITOREO PdG",
    },
    {
      id: 44,
      monthBoletin: "DIC",
      nameBoletin: "Primer Informe Perspectiva de Género",
    },
    {
      id: 45,
      monthBoletin: "DIC",
      nameBoletin: "Segundo Informe Perspectiva de Género",
    },
    {
      id: 46,
      monthBoletin: "DIC",
      nameBoletin: "Informe Final Monitoreo PG",
    },
  ],

  2023: [
    {
      id: 1,
      monthBoletin: "NOV",
      nameBoletin: "Primer Reporte Quincenal",
    },
    {
      id: 2,
      monthBoletin: "DIC",
      nameBoletin: "Segundo Reporte Quincenal",
    },
    {
      id: 3,
      monthBoletin: "DIC",
      nameBoletin: "Tercer Reporte Quincenal",
    },
    {
      id: 4,
      monthBoletin: "DIC",
      nameBoletin: "Cuarto Reporte Quincenal",
    },
  ],
};
